import store from "../../redux/store";
import {
  logoutCashierCall,
  setCurrentCashier,
  refreshCashierAuthCall,
} from "../../redux/actions/cashierActions";

export const getCashierRefreshToken = () => {
  if (localStorage.cashierRefreshToken) {
    const refTokenObj = JSON.parse(localStorage.cashierRefreshToken);
    const { token } = refTokenObj;

    return token;
  }
};

const checkForRefreshToken = (resolve, reject) => {
  if (localStorage.cashierRefreshToken) {
    const refTokenObj = JSON.parse(localStorage.cashierRefreshToken);
    const { token, expires } = refTokenObj;

    if (new Date(`${expires}`) < Date.now()) {
      // cashierRefreshToken expires logout now
      store.dispatch(logoutCashierCall());
      return reject("Cashier Refresh token expires");
    } else {
      store.dispatch(
        refreshCashierAuthCall({
          refreshToken: token,
        })
      );
    }
  } else {
    // cashierRefreshToken not exist, logout now
    store.dispatch(logoutCashierCall());
    return reject("Refresh token not exist");
  }
};

// it should be called on cashier route onmount, for one time only

export const checkCashierAuthOnHome = () => {
  return new Promise((resolve, reject) => {
    if (localStorage?.cashierAccessToken) {
      const tokenObj = JSON.parse(localStorage?.cashierAccessToken);
      const { expires } = tokenObj;

      if (new Date(`${expires}`) < Date.now()) {
        // check for cashier refresh token
        checkForRefreshToken(resolve, reject);
      } else {
        //set user and isAuthenticated
        store.dispatch(setCurrentCashier(tokenObj));
      }
    }
    return resolve("success");
  });
};
